import { defineMessages } from 'react-intl';

/** The copy of the Pitch home (design outreach-v2 i1, i2). */
export const homeMessages = defineMessages({
  title: { id: 'app.outreach.home.title', defaultMessage: 'Pitch' },
  intro: {
    id: 'app.outreach.home.intro',
    defaultMessage:
      'Tell the right people about your release. Plug finds the playlists, press and radio that fit your sound, writes to each one, and shows you what worked.',
  },
  yourSound: { id: 'app.outreach.home.yourSound', defaultMessage: 'Your sound' },
  mailboxes: { id: 'app.outreach.home.mailboxes', defaultMessage: 'Mailboxes' },

  pitchASong: { id: 'app.outreach.home.pitchASong', defaultMessage: 'Pitch a song' },

  freePlanTitle: {
    id: 'app.outreach.home.free.planTitle',
    defaultMessage: '{count, plural, one {# playlist adds} other {# playlists add}} songs like yours',
  },

  totalSent: { id: 'app.outreach.home.total.pitched', defaultMessage: 'Pitched in 28 days' },
  totalListened: { id: 'app.outreach.home.total.listened', defaultMessage: 'Listened' },
  totalListenedHint: {
    id: 'app.outreach.home.total.listenedHint',
    defaultMessage: '{percent}% opened the pitch page and pressed play',
  },
  totalReplied: { id: 'app.outreach.home.total.replied', defaultMessage: 'Replied' },
  totalRepliedHint: { id: 'app.outreach.home.total.repliedHint', defaultMessage: '{percent}% of the pitches' },
  totalPlaced: { id: 'app.outreach.home.total.added', defaultMessage: 'Added your songs' },
  totalPlacedHint: {
    id: 'app.outreach.home.total.placedHint',
    defaultMessage: '{detected} found by MUSIC24 in the playlist data, {fromReplies} from replies',
  },

  // design outreach-v2 i1: the campaign rows with the rate of each campaign.
  campaignsTitle: { id: 'app.outreach.home.campaigns.pitching', defaultMessage: 'Songs Plug is pitching' },
  campaignsShared: { id: 'app.outreach.home.campaigns.shared', defaultMessage: '{rate} a day, shared' },
  campaignsRate: { id: 'app.outreach.home.campaigns.rate', defaultMessage: '{rate} a day' },
  rowRate: { id: 'app.outreach.home.campaigns.rowRate', defaultMessage: 'a day' },
  rowOut: { id: 'app.outreach.home.campaigns.out', defaultMessage: 'Out {date}' },
  rowOutNoDate: { id: 'app.outreach.home.campaigns.noDate', defaultMessage: 'No release day' },
  rowUntil: { id: 'app.outreach.home.campaigns.until', defaultMessage: 'until {date}' },
  rowEnded: {
    id: 'app.outreach.home.campaigns.ended',
    defaultMessage:
      'Ended · {sent, plural, one {# pitched} other {# pitched}} · {added, plural, one {# add} other {# adds}}',
  },
  rowDraft: { id: 'app.outreach.home.campaigns.draft', defaultMessage: 'Setup not finished' },
  chipPitching: { id: 'app.outreach.home.campaigns.chip.pitching', defaultMessage: 'Pitching' },
  chipLooking: { id: 'app.outreach.home.campaigns.chip.looking', defaultMessage: 'Looking' },
  chipReview: { id: 'app.outreach.home.campaigns.chip.review', defaultMessage: 'Waits for you' },
  chipPaused: { id: 'app.outreach.home.campaigns.chip.paused', defaultMessage: 'Paused' },
  chipDone: { id: 'app.outreach.home.campaigns.chip.done', defaultMessage: 'Done' },
  chipDraft: { id: 'app.outreach.home.campaigns.chip.draft', defaultMessage: 'Draft' },
  open: { id: 'app.outreach.home.campaigns.open', defaultMessage: 'Open' },
  results: { id: 'app.outreach.home.campaigns.results', defaultMessage: 'Results' },
  allResults: { id: 'app.outreach.home.allResults', defaultMessage: 'All results' },

  // design outreach-v2 i1 hero: today of the artist.
  todayEyebrow: { id: 'app.outreach.home.today.eyebrow', defaultMessage: 'Today' },
  todaySent: {
    id: 'app.outreach.home.today.sent',
    defaultMessage: 'Plug pitched {count, plural, one {# person} other {# people}} today for {artist}',
  },
  todayNone: {
    id: 'app.outreach.home.today.none',
    defaultMessage: 'Plug pitches {rate} new {rate, plural, one {person} other {people}} a day for {artist}',
  },
  todayGoingOut: {
    id: 'app.outreach.home.today.goingOut',
    defaultMessage: '{count, plural, one {# more goes} other {# more go}} out today.',
  },
  todayNext: { id: 'app.outreach.home.today.next', defaultMessage: 'The next pitches go out in the next batch.' },
  todayWaiting: {
    id: 'app.outreach.home.today.waiting',
    defaultMessage: '{count, plural, one {# waits} other {# wait}} for you',
  },
  todayRing: { id: 'app.outreach.home.today.ring', defaultMessage: '{sent} of {rate} pitched today' },
  todayQueueFull: {
    id: 'app.outreach.home.today.queueFull',
    defaultMessage: 'Plug picks no new people until you review the pitches that wait.',
  },

  // design outreach-v2 i1 rate card.
  rateTitle: { id: 'app.outreach.home.rate.title', defaultMessage: 'a day for {artist}' },
  rateLabel: {
    id: 'app.outreach.home.rate.label',
    defaultMessage: 'Ultra plan. Each of your artists has their own {rate} a day.',
  },
  rateManager: {
    id: 'app.outreach.home.rate.manager',
    defaultMessage: 'Max plan. Each of your artists has their own {rate} a day. Ultra pitches {label}.',
  },
  rateSolo: {
    id: 'app.outreach.home.rate.solo',
    defaultMessage: 'On Ultra, Plug pitches {label} new people a day for each artist, with autopilot.',
  },
  rateOffer: { id: 'app.outreach.home.rate.offer', defaultMessage: 'Pitch {label} a day on Ultra' },
  rateAskOwner: { id: 'app.outreach.home.rate.askOwner', defaultMessage: 'Ask the workspace owner' },

  latest: { id: 'app.outreach.home.latest', defaultMessage: 'Latest' },
  inbox: { id: 'app.outreach.home.latest.inbox', defaultMessage: 'Inbox' },
  latestEmpty: {
    id: 'app.outreach.home.latest.empty',
    defaultMessage: 'Replies, listens and adds show here as they come in.',
  },
  mailboxSettings: { id: 'app.outreach.home.mailboxes.settings', defaultMessage: 'Settings' },
  mailboxWarming: {
    id: 'app.outreach.home.mailboxes.warming',
    defaultMessage: 'Day {day} of {total} · {cap} a day now',
  },
  mailboxReady: { id: 'app.outreach.home.mailboxes.ready', defaultMessage: 'Ready · {cap} a day' },

  // design outreach-v2 i2: the first visit (no campaign yet).
  firstEyebrow: { id: 'app.outreach.home.first.eyebrow', defaultMessage: 'Pitch' },
  firstTitle: {
    id: 'app.outreach.home.first.pitchTitle',
    defaultMessage: 'Plug pitches your song to new curators, every day',
  },
  firstBody: {
    id: 'app.outreach.home.first.pitchBody',
    defaultMessage:
      'Playlists, blogs, newsletters, radio and creators that fit your sound. Personal emails from your own mailbox. You see each reply and each add.',
  },
  firstStep1Title: { id: 'app.outreach.home.first.s1Title', defaultMessage: '1 · Pick a song' },
  firstStep1Body: { id: 'app.outreach.home.first.s1Body', defaultMessage: 'And who Plug pitches first.' },
  firstStep2Title: { id: 'app.outreach.home.first.s2Title', defaultMessage: '2 · Connect your mailbox' },
  firstStep2Body: { id: 'app.outreach.home.first.s2Body', defaultMessage: 'Two minutes. Replies come to you.' },
  firstStep3Title: { id: 'app.outreach.home.first.s3Title', defaultMessage: '3 · Plug does the rest' },
  firstStep3Body: {
    id: 'app.outreach.home.first.s3Body',
    defaultMessage: '{pro} new people a day on Pro, {label} on Ultra.',
  },
  firstPitchSong: { id: 'app.outreach.home.first.pitchSong', defaultMessage: 'Pitch {song}' },
  firstPickAnother: { id: 'app.outreach.home.first.pickAnother', defaultMessage: 'Pick another song' },
  firstPickSong: { id: 'app.outreach.home.first.pickSong', defaultMessage: 'Pick a song' },
  firstSoon: {
    id: 'app.outreach.home.first.soon',
    defaultMessage:
      '{song} is out {days, plural, =0 {today} one {in # day} other {in # days}}: the best time to pitch.',
  },

  mailboxesNone: {
    id: 'app.outreach.home.mailboxes.none',
    defaultMessage:
      'Connect your own mailbox to send pitches: Gmail, iCloud or any IMAP mailbox. Pitches from your own address get more replies, and the replies land in your inbox.',
  },
  connectMailbox: { id: 'app.outreach.home.mailboxes.connect', defaultMessage: 'Connect your mailbox' },
});
